/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import { IMfrmReasonsToBuyData } from './mfrm-reasons-to-buy.data';
import { IMfrmReasonsToBuyProps } from './mfrm-reasons-to-buy.props.autogenerated';
import getRTBData, { GetReasonsToBuyDataInput } from '../../data-actions/get-resons-to-buy-data.action';

export interface IMfrmReasonsToBuyViewProps extends IMfrmReasonsToBuyProps<IMfrmReasonsToBuyData> {
    reasonToBuyData: IReasonToBuyData[]
    reasonsToBuyContainer: IModuleProps;
}
export interface IReasonToBuyData {
    heading?: string;
    description?: Msdyn365.RichText;
    icon?: Msdyn365.IImageData;
}
interface IReasonsToBuyState {
    reasonsToBuyData: IReasonToBuyData[];
}
/**
 *
 * MfrmReasonsToBuy component
 * @extends {React.PureComponent<IMfrmReasonsToBuyProps<IMfrmReasonsToBuyData>>}
 */
class MfrmReasonsToBuy extends React.PureComponent<IMfrmReasonsToBuyProps<IMfrmReasonsToBuyData>, IReasonsToBuyState> {
    constructor(props: IMfrmReasonsToBuyProps<IMfrmReasonsToBuyData>) {
        super(props);
        this.state = {
            reasonsToBuyData: []
        };
    }
    public componentDidMount(): void {
        const { data } = this.props;
        const categoryName = data.categoryPaths.result && data.categoryPaths.result[0].Name;
        this._getReasonsToBuyData(categoryName)
            .then(reasonsToBuy => {
                this.setState({
                    reasonsToBuyData: reasonsToBuy ? reasonsToBuy : []
                });
            })
            .catch(error => {
                this.props.context.telemetry.exception(error);
                throw new Error('Unable to find reasons to buy data');
            });
    }
    public render(): JSX.Element | null {
        const reasonsToBuyviewProps = {
            ...this.props,
            reasonsToBuyContainer: {
                moduleProps: this.props
            },
            reasonToBuyData: this.state.reasonsToBuyData
        };

        return this.props.renderView(reasonsToBuyviewProps) as React.ReactElement;
    }
    private _getReasonsToBuyData = async (categoryName: string | undefined): Promise<any> => {
        const rtbInput = new GetReasonsToBuyDataInput(categoryName ?? '');
        const rtbData = await getRTBData(rtbInput, this.props.context.actionContext);
        return rtbData;
    };
}

export default MfrmReasonsToBuy;
